module.exports = __webpack_public_path__ + "img/google-play-badge.7742c533.png";